import React, { useRef, useState, useEffect, useContext } from "react";
import * as S from "./styles";
import { Formik, Form, Field } from "formik";
import InputText from "../../components/InputText";
import Button from "../../components/Button";
import Navbar from "../../components/Navbar";
import Lojas from "../../assets/navbar/Lojas_on_light_blue.svg";
import api from "../../services/api";
import history from "../../utils/history";
import validationSchema from "./validations/validationSchema";
import { toast } from "react-toastify";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import { useParams } from "react-router-dom";

import SkeletonRadioInput from "../../components/SkeletonRadioInput";
import Skeleton from "../../components/skeleton";
import { Context } from "../../context/globalContext";
import PoPup from "../../components/PopUp";
import AutoCompleteSearch from "../../components/AutoCompleteSearch";
import ListCompanyType from "../../components/ListCompanyTypes";
import ListCategoryStoreType from "../../components/ListCategoryStoreType";
import TextArea from "../../components/TextArea";
import ListLog from "../../components/ListLog";

import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../../components/Button-v2";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";

export default function StoreRegistration() {
  const formRef = useRef(null);
  const [formData, setFormData] = useState();
  const { id } = useParams();

  const [initialValues, setInitialValues] = useState({
    id: null,
    pessoaId: null,
    cpfCnpj: "",
    razaosocial: "",
    nome: "",
    cidade: "",
    estado: "",
    nomeLoja: "",
    codigoIntegracao: "",
    codigoUnicad: "",
    possuiAgente: "Não",
    agente: "",
    nomeAgente: "",
    convenio: "",
    convenioLoja: "",
    agenteId: null,
    convenioId: null,
    status: true,
    pessoaJuridicaId: null,
    tipoEmpresa: null,
    tipoEmpresaCadastrado: false,
    observacao: "",
    categoriaLoja: null,
  });
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupActivateOpen, setPopupActivateOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({ id: null, cpf: null });
  const globalContext = useContext(Context);

  async function getDataByUserId() {
    globalContext.setIsLoading(true);
    const response = await api.get(`/api/loja/pessoa/${id}`);
    console.log(response.data);
    if (response?.data) {
      const enderecos = response?.data?.pessoa?.enderecos;
      let cidade =
        response?.data?.pessoa?.enderecos?.[0]?.municipio?.descricao?.toUpperCase();
      let estado =
        response?.data?.pessoa?.enderecos?.[0]?.municipio?.estado?.nome?.toUpperCase();
      if (enderecos && enderecos.length > 0) {
        cidade =
          response?.data?.pessoa?.enderecos?.[
            enderecos?.length - 1
          ]?.municipio?.descricao?.toUpperCase();
        estado =
          response?.data?.pessoa?.enderecos?.[
            enderecos?.length - 1
          ]?.municipio?.estado?.nome?.toUpperCase();
      }
      setInitialValues({
        ...initialValues,
        id: response?.data?.id,
        pessoaId: response?.data?.pessoa?.id,
        cpfCnpj: response?.data?.pessoa?.cpfCnpj,
        razaosocial: response?.data?.pessoa?.nome,
        nome: response?.data?.pessoa?.nomeFantasia,
        pessoaJuridicaId: response?.data?.pessoa?.pessoaJuridica?.id,
        tipoEmpresa: response?.data?.pessoa?.pessoaJuridica?.tipoEmpresa,
        tipoEmpresaCadastrado:
          response?.data?.pessoa?.pessoaJuridica?.tipoEmpresa !== null,
        cidade: cidade,
        estado: estado,
        nomeLoja: response?.data?.nomeLoja,
        codigoIntegracao: response?.data?.codIntegracaoFin,
        codigoUnicad: response?.data?.codUnicad,
        status: response?.data?.status,
        observacao: response?.data?.observacao,
        categoriaLoja: { id: response?.data?.categoriaLoja },
        categoriaLojaCadastrada: response?.data?.categoriaLoja !== null,
        possuiAgente:
          Object.keys(response?.data?.agente || {}).length === 0
            ? "Não"
            : "Sim",
        agenteId:
          Object.keys(response?.data?.agente || {}).length === 0
            ? null
            : response?.data?.agente?.id,
        agenteLoja:
          Object.keys(response?.data?.agente || {}).length === 0
            ? ""
            : response?.data?.agente?.nomeAgente,
        agente:
          Object.keys(response?.data?.agente || {}).length === 0
            ? ""
            : response?.data?.agente?.pessoa?.cpfCnpj,
        convenioId:
          Object.keys(response?.data?.agente || {}).length === 0
            ? response?.data?.convenio?.id
            : null,
        convenioLoja:
          Object.keys(response?.data?.agente || {}).length === 0
            ? response?.data?.convenio?.nomeConvenio
            : "",
        convenio:
          Object.keys(response?.data?.agente || {}).length === 0
            ? response?.data?.convenio?.pessoa?.cpfCnpj
            : "",
      });
    }
    globalContext.setIsLoading(false);
  }

  useEffect(() => {
    if (id) {
      getDataByUserId();
    }
  }, [id]);

  async function onBlurCnpj(cpfCnpj) {
    if (cpfCnpj.length !== 14) {
      return;
    }
    globalContext.setIsLoading(true);

    try {
      const response = await api.get(
        `api/pessoa/buscar?cpfCnpjOuNome=${cpfCnpj}&tipoPessoa=PESSOA_JURIDICA`
      );
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        console.log(response.data.content);
        const content = response?.data?.content;
        const enderecos = content?.[0]?.enderecos;
        let municipio =
          content?.[0]?.enderecos?.[0]?.municipio?.descricao?.toUpperCase();
        let uf =
          content?.[0]?.enderecos?.[0]?.municipio?.estado?.nome?.toUpperCase();
        if (enderecos && enderecos.length > 1) {
          municipio =
            content?.[0]?.enderecos?.[
              enderecos?.length - 1
            ]?.municipio?.descricao?.toUpperCase();
          uf =
            content?.[0]?.enderecos?.[
              enderecos?.length - 1
            ]?.municipio?.estado?.nome?.toUpperCase();
        }

        setInitialValues({
          ...initialValues,
          cpfCnpj: content?.[0]?.cpfCnpj,
          pessoaId: content?.[0]?.id,
          razaosocial: content?.[0]?.nome,
          nome: content?.[0]?.nomeFantasia,
          nomeAgente: content?.[0]?.nome,
          cidade: municipio,
          estado: uf,
          tipoEmpresa: content?.[0]?.pessoaJuridica?.tipoEmpresa,
          tipoEmpresaCadastrado:
            content?.[0]?.pessoaJuridica?.tipoEmpresa !== null,
          categoriaLoja: { id: content?.[0]?.categoriaLoja },
          categoriaLojaCadastrada: content?.[0]?.categoriaLoja !== null,
        });
      } else if (!response) {
        setInitialValues({
          ...initialValues,
        });
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  }

  useEffect(() => {
    Object.keys(formRef.current.values).length >= 1
      ? setFormData(true)
      : setFormData(false);
  }, [formRef, formData]);

  const sendData = async (values) => {
    if (!values.pessoaId || values.pessoaId === null) {
      toast.error("Digite um cnpj válido.");
      return;
    }

    if (values.agenteId === null && values.convenioId === null) {
      toast.error("Selecione um agente ou um convênio para esta loja.");
      return;
    }

    if (!values.tipoEmpresa || values.tipoEmpresa === null) {
      toast.error("Selecione o tipo de empresa.");
      return;
    }
    globalContext.setIsLoading(true);

    const dataSending = {
      id: values.id !== null ? values.id : null,
      nomeLoja: values.nomeLoja,
      codIntegracaoFin: values.codigoIntegracao,
      codUnicad: values.codigoUnicad,
      observacao: values.observacao,
      agente:
        values.possuiAgente === "Sim"
          ? values.agenteId !== null
            ? {
                id: values.agenteId,
              }
            : null
          : null,
      pessoa:
        values.pessoaId !== null
          ? {
              id: values.pessoaId,
              pessoaJuridica:
                values.pessoaJuridicaId !== null
                  ? {
                      id: values.pessoaJuridicaId,
                      tipoEmpresa: values.tipoEmpresa,
                    }
                  : null,
            }
          : null,
      convenio:
        values.possuiAgente === "Não"
          ? values.convenioId !== null
            ? {
                id: values.convenioId,
              }
            : null
          : null,
      status: values.status,
      categoriaLoja: values.categoriaLoja.id,
    };

    if (values?.id && values?.id !== null) {
      try {
        const response = await api.put(`api/loja/${values.id}`, dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          toast.success("Dados atualizado com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao atualizar, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao atualizar, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    } else {
      try {
        const response = await api.post(`api/loja`, dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          if (values?.pessoaId !== null) {
            history?.push(`/cadastro-lojas/${values?.pessoaId}`);
          } else {
            const content = response?.data?.content;
            if (content !== null && content !== undefined) {
              if (content?.pessoa?.id !== null) {
                history?.push(`/cadastro-lojas/${content?.pessoa?.id}`);
              }
            }
          }

          toast.success("Dados cadastrados com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao cadastrar, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao cadastrar, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    }
  };

  const handleSubmit = async () => {
    if (formRef.current) {
      if (formRef.current.isValid) {
        sendData(formRef.current.values);
      }
    }
  };

  const selectAutocomplete = async (item, type) => {
    if (type === "AGENTE") {
      setInitialValues({
        ...initialValues,
        agenteId: item?.id,
        agente: item?.cpfCnpj || "",
        agenteLoja: item?.nome || "",
      });
    } else if (type === "CONVENIO") {
      setInitialValues({
        ...initialValues,
        agenteId: null,
        agente: "",
        agenteLoja: "",
        convenioId: item?.id,
        convenio: item?.cpfCnpj || "",
        convenioLoja: item?.nome || "",
      });
    }
  };

  return (
    <>
      <Navbar className="navbar" />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={Lojas} />
            <div>
              <S.Title>Lojas</S.Title>
              <S.Description>Cadastro geral de lojas</S.Description>
            </div>
          </S.BoxUser>
        </S.Header>
        <S.Content>
          <Formik
            innerRef={formRef}
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values) => handleSubmit()}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <Field
                  name="cpfCnpj"
                  id="cpfCnpj"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="58%"
                        label="CNPJ*:"
                        maskChar=""
                        disabled={id}
                        mask="99.999.999/9999-99"
                        onChange={(e) => {
                          onBlurCnpj(desmaskIfNumber(e.target.value));
                          setFieldValue("cpfCnpj", e.target.value);
                        }}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <p>{errors.cpfCnpj}</p>
                <Field
                  name="razaosocial"
                  id="razaosocial"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="58%"
                        disabled
                        label="Razão Social*:"
                        currency="false"
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <Field
                  name="nome"
                  id="nome"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        disabled
                        width="58%"
                        label="Nome fantasia*:"
                        currency="false"
                        error={errors.nome && touched.nome}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <Field
                  name="tipoEmpresaLoja"
                  id="tipoEmpresaLoja"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <ListCompanyType
                        {...field}
                        width="58%"
                        disabled={initialValues.tipoEmpresaCadastrado}
                        label="Tipo de empresa*:"
                        currency="false"
                        value={initialValues.tipoEmpresa?.id}
                        onChange={(e) => {
                          setInitialValues({
                            ...initialValues,
                            tipoEmpresa: e,
                          });
                        }}
                        error={errors.tipoEmpresa && touched.tipoEmpresa}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <Field
                  name="categoriaLoja"
                  id="categoriaLoja"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <ListCategoryStoreType
                        {...field}
                        width="58%"
                        // disabled={initialValues.categoriaLojaCadastrada}
                        label="Categoria loja*:"
                        currency="false"
                        value={initialValues.categoriaLoja?.id}
                        onChange={(e) => {
                          setInitialValues({
                            ...initialValues,
                            categoriaLoja: e,
                          });
                        }}
                        error={errors.categoriaLoja && touched.categoriaLoja}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <S.InputBox>
                  <Field
                    name="cidade"
                    id="cidade"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Cidade:"
                          {...field}
                          disabled
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="estado"
                    id="estado"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Estado:"
                          {...field}
                          disabled
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <Field
                  name="nomeLoja"
                  id="nomeLoja"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        width="58%"
                        disabled={id && initialValues.status === false}
                        label="Nome da Loja:"
                        currency="false"
                        onChange={(e) => {
                          setInitialValues({
                            ...initialValues,
                            nomeLoja: e.target.value,
                          });
                        }}
                        error={errors.nomeLoja && touched.nomeLoja}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <S.InputBox>
                  <Field
                    name="codigoIntegracao"
                    id="codigoIntegracao"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Código de Integração financeira*:"
                          maskChar=""
                          mask="9999999"
                          disabled="true"
                          currency="false"
                          onChange={(e) => {
                            setInitialValues({
                              ...initialValues,
                              codigoIntegracao: e.target.value,
                            });
                          }}
                          error={
                            errors.codigoIntegracao && touched.codigoIntegracao
                          }
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="codigoUnicad"
                    id="codigoUnicad"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled={id && initialValues.status === false}
                          label="Código Unicad:"
                          currency="false"
                          onChange={(e) => {
                            setInitialValues({
                              ...initialValues,
                              codigoUnicad: e.target.value,
                            });
                          }}
                          error={errors.codigoUnicad && touched.codigoUnicad}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.TextAreaBox>
                  <Field
                    name="observacao"
                    id="observacao"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <TextArea
                          {...field}
                          type="text"
                          label="Observação:"
                          onChange={(e) => {
                            setFieldValue("observacao", e.target.value);
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.TextAreaBox>

                <S.InputRadioBox>
                  <Field
                    name="possuiAgente"
                    id="possuiAgente"
                    render={({ field }) => (
                      <S.InputRadio>
                        {!globalContext.isLoading ? (
                          <p>Esta loja possui agente?</p>
                        ) : (
                          <Skeleton type="radioParagraph" />
                        )}

                        <div className="boxradio">
                          <label>
                            {!globalContext.isLoading ? (
                              <>
                                <input
                                  type="radio"
                                  name="possuiAgente"
                                  className="radio"
                                  value="Sim"
                                  disabled={
                                    id && initialValues.status === false
                                  }
                                  checked={values.possuiAgente === "Sim"}
                                  onChange={() => {
                                    setInitialValues({
                                      ...initialValues,
                                      possuiAgente: "Sim",
                                    });
                                    setFieldValue("possuiAgente", "Sim");
                                  }}
                                />
                                Sim
                              </>
                            ) : (
                              <SkeletonRadioInput />
                            )}
                          </label>

                          <label>
                            {!globalContext.isLoading ? (
                              <>
                                <input
                                  type="radio"
                                  name="possuiAgente"
                                  className="radio"
                                  value="Não"
                                  disabled={
                                    id && initialValues.status === false
                                  }
                                  checked={values.possuiAgente === "Não"}
                                  onChange={() => {
                                    setInitialValues({
                                      ...initialValues,
                                      possuiAgente: "Não",
                                    });
                                    setFieldValue("possuiAgente", "Não");
                                  }}
                                />
                                Não
                              </>
                            ) : (
                              <SkeletonRadioInput />
                            )}
                          </label>
                        </div>
                      </S.InputRadio>
                    )}
                  ></Field>
                </S.InputRadioBox>

                {values.possuiAgente === "Sim" ? (
                  <>
                    {!globalContext.isLoading ? (
                      <AutoCompleteSearch
                        label="Digite um novo CPF/CNPJ/Nome de agente para buscar..."
                        handleSearch={selectAutocomplete}
                        updated={values?.possuiAgente}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )}

                    <Field
                      name="agente"
                      id="agente"
                      render={({ field }) =>
                        !globalContext.isLoading ? (
                          <InputText
                            {...field}
                            width="58%"
                            maskChar=""
                            mask="99.999.999/9999-99"
                            type="text"
                            label="CPF/Cnpj do Agente:"
                            disabled
                            currency="false"
                            error={errors.agente && touched.agente}
                          />
                        ) : (
                          <Skeleton type="input" />
                        )
                      }
                    />

                    <Field
                      name="agenteLoja"
                      id="agenteLoja"
                      render={({ field }) =>
                        !globalContext.isLoading ? (
                          <InputText
                            {...field}
                            disabled
                            type="text"
                            width="58%"
                            label="Nome Agente:"
                            error={errors.agenteLoja && touched.agenteLoja}
                          />
                        ) : (
                          <Skeleton type="input" />
                        )
                      }
                    />
                  </>
                ) : (
                  <>
                    {!globalContext.isLoading ? (
                      <AutoCompleteSearch
                        label="Digite um novo CPF/CNPJ/Nome de convênio para buscar..."
                        handleSearch={selectAutocomplete}
                        updated={values?.possuiAgente}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )}

                    <Field
                      name="convenio"
                      id="convenio"
                      render={({ field }) =>
                        !globalContext.isLoading ? (
                          <InputText
                            {...field}
                            width="58%"
                            type="text"
                            maskChar=""
                            mask="99.999.999/9999-99"
                            label="Convênio:"
                            currency="false"
                            disabled
                            error={errors.convenio && touched.convenio}
                          />
                        ) : (
                          <Skeleton type="input" />
                        )
                      }
                    />

                    <Field
                      name="convenioLoja"
                      id="convenioLoja"
                      render={({ field }) =>
                        !globalContext.isLoading ? (
                          <InputText
                            {...field}
                            disabled
                            width="58%"
                            type="text"
                            label="Nome Convênio:"
                            currency="false"
                            error={errors.convenioLoja && touched.convenioLoja}
                          />
                        ) : (
                          <Skeleton type="input" />
                        )
                      }
                    />
                  </>
                )}
              </Form>
            )}
          </Formik>
          <S.ButtonContainer>
            <S.ButtonExclude>
              {id && initialValues.status === true ? (
                <Button
                  button="primary"
                  className="inativar"
                  onClick={() => {
                    setPopupOpen(true);
                    setUserSelected({
                      id: initialValues.id,
                      cpf: initialValues.cpfCnpj,
                    });
                  }}
                >
                  Inativar cadastro
                </Button>
              ) : initialValues.status ? (
                <></>
              ) : (
                <Button button="primary" className="inativo">
                  Cadastro inativo
                </Button>
              )}
            </S.ButtonExclude>

            <Button button="primary" onClick={history.goBack}>
              Voltar
            </Button>
            {id && initialValues.status === false ? (
              <Button
                button="primary"
                onClick={() => {
                  setPopupActivateOpen(true);
                  setUserSelected({
                    id: initialValues.id,
                    cpf: initialValues.cpfCnpj,
                    status: true,
                  });
                }}
              >
                Ativar cadastro
              </Button>
            ) : (
              <Button button="primary" onClick={() => handleSubmit()}>
                Salvar cadastro
              </Button>
            )}
          </S.ButtonContainer>
        </S.Content>
        <S.Content>
          {initialValues?.id && (
            <ListLog entidadeId={initialValues.id} nomeEntidade="Loja" />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Content>
      </S.Wrapper>
      {popupOpen && (
        <PoPup
          setIsLoading={globalContext.setIsLoading}
          setOpenPopup={setPopupOpen}
          userSelected={userSelected}
          updateList={getDataByUserId}
          endPoint="api/loja/"
          inativar={true}
          ativar={false}
          showCpfCnpj={false}
          textExclude={
            "Você deseja realmente inativar este cadastro e também os usuários vinculados a ele?"
          }
          messageFailed={"Error ao inativar a loja com o CNPJ"}
          messageSuccess={"Sucesso ao inativar a loja"}
        />
      )}
      {popupActivateOpen && (
        <PoPup
          setIsLoading={globalContext.setIsLoading}
          setOpenPopup={setPopupActivateOpen}
          userSelected={initialValues}
          updateList={getDataByUserId}
          endPoint="api/loja/"
          inativar={false}
          ativar={true}
          showCpfCnpj={false}
          textExclude={"Você deseja realmente ativar este cadastro?"}
          messageFailed={"Error ao ativar a loja com o CNPJ"}
          messageSuccess={"Sucesso ao ativar a loja"}
        />
      )}
    </>
  );
}
